import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "./Component/Components/Navbar/Navbar";
import Home from "./Component/Pages/Home/Home";
import Footer from "./Component/Components/Footer/Footer";
import Services from "./Component/Pages/services/Services";
import About from "./Component/Pages/About/About";
import Contact from "./Component/Pages/About/Contact/Contact";
import SendData from "./Component/Pages/FormSendData/SendData";
import Admin from "./Component/Pages/AdminDashbord/Admin";
import Login from "./Component/Pages/AdminDashbord/Login";
import Dashboard from "./Component/Pages/AdminDashbord/Admin"; // استيراد لوحة التحكم

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const hideNavbarFooter = location.pathname === "/Admin" || location.pathname === "/Dashboard";

  useEffect(() => {
    if (location.pathname === "/Admin" && !isLoggedIn) {
      navigate("/Login");
    }
  }, [location, isLoggedIn, navigate]);

  const handleLogin = (email, password) => {
    // استبدل هذا الشرط بتحقق تسجيل الدخول الفعلي
    if (email === "rabea" && password === "rabea") {
      setIsLoggedIn(true);
      navigate("/Admin");
    } else {
      alert("البريد الإلكتروني أو كلمة المرور غير صحيحة");
    }
  };

  return (
    <div dir="rtl" className="App">
      <div>
        {!hideNavbarFooter && <Navbar />}
        <Routes>
          <Route index element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/SendData" element={<SendData />} />
          <Route path="/Admin" element={<Admin />} />
          <Route path="/Login" element={<Login onLogin={handleLogin} />} />
          <Route path="/Dashboard" element={<Dashboard />} /> {/* إضافة مسار لوحة التحكم */}
        </Routes>
        {!hideNavbarFooter && <Footer />}
      </div>
    </div>
  );
}

export default App;
